import {showModal, showModalAlert} from './modal';

function qs(sel) {
    return document.querySelector(sel);
}

function csrf() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
}

async function postJson(url, body) {
    const res = await fetch(url, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'X-CSRF-TOKEN': csrf()},
        body: JSON.stringify(body),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) {
        throw new Error(data.error || `HTTP ${res.status}`);
    }
    return data;
}

function renderContent(rows) {
    const tbody = qs('#capture-content-body');
    if (!rows || rows.length === 0) {
        tbody.innerHTML = `<tr><td class="py-3 text-gray-500" colspan="4">Keine Scans.</td></tr>`;
        return;
    }


    tbody.innerHTML = rows.map(r => {
        const minusBtn = `<button data-minus-articles="${r.ebox_id}_${r.ean}" class="px-6 py-3 rounded bg-gray-200 hover:bg-gray-300">-</button>`;

        return `
    <tr class="border-b">
      <td class="py-2 pr-3">${r.ean}</td>
      <td class="py-2 pr-3">${r.name || ''}</td>
      <td class="py-2 pr-3 font-semibold">${r.qty}</td>
      <td class="py-2 pr-3 whitespace-nowrap">${r.last_scan}</td>
      <td class="py-2 pr-3 text-right">${minusBtn}</td>
    </tr>`;
    }).join('');
}

function renderHistory(rows) {
    const tbody = qs('#history-body');
    if (!rows || rows.length === 0) {
        tbody.innerHTML = `<tr><td class="py-3 text-gray-500" colspan="7">Noch keine Scans.</td></tr>`;
        return;
    }

    tbody.innerHTML = rows.map(r => {
        const print = r.print_status === 'printed'
            ? `<span class="text-green-700">OK</span>`
            : r.print_status === 'failed'
                ? `<span class="text-red-700">FEHLER</span>`
                : `<span class="text-gray-600">…</span>`;

        const price = (r.price != null) ? `${Number(r.price).toFixed(2)} €` : '—';

        const minusBtn = `<button data-minus="${r.id}" class="px-6 py-3 rounded bg-gray-200 hover:bg-gray-300">-</button>`;

        return `
      <tr class="border-b">
        <td class="py-2 pr-3 whitespace-nowrap">${r.scanned_at}</td>
        <td class="py-2 pr-3">${r.ean}</td>
        <td class="py-2 pr-3">${r.name || ''}</td>
        <td class="py-2 pr-3 font-semibold">${r.qty_delta}</td>
        <td class="py-2 pr-3">${price}</td>
        <td class="py-2 pr-3">${print}</td>
        <td class="py-2 pr-3 text-right">${minusBtn}</td>
      </tr>
    `;
    }).join('');
}

function setLast(scan) {
    const lastLine = qs('#last-line');
    const lastMeta = qs('#last-meta');
    if (!scan) {
        lastLine.textContent = '—';
        lastMeta.textContent = '';
        return;
    }
    lastLine.textContent = `${scan.ean} – ${scan.name}`;
    lastMeta.textContent = `Preis: ${Number(scan.price).toFixed(2)} € | Druck: ${scan.print_status} | Zeit: ${scan.scanned_at}`;
}

function enableInputs(enabled) {
    ['#supplier_id', '#e_number', '#quantity', '#ean', '#btn-new-ebox'].forEach(id => {
        const el = qs(id);
        if (!el) return;
        el.disabled = !enabled;
        el.classList.toggle('opacity-50', !enabled);
    });
}

async function loadHistoryForENumber(eNumber) {
    const url = new URL(window.__CAPTURE_ENDPOINTS__.eboxDetails, window.location.origin);
    url.searchParams.set('e_number', eNumber);
    const res = await fetch(url.toString(), {headers: {'Accept': 'application/json'}});
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) return;
    renderHistory(data.history || []);
    renderContent(data.content || []);
}

function initCapture() {
    if (!window.__CAPTURE_ENDPOINTS__) return;

    const supplier = qs('#supplier_id');
    const eNumber = qs('#e_number');
    const quantity = qs('#quantity');
    const ean = qs('#ean');
    const scan_ohne_druck_input = qs('#scan_ohne_druck');

    // load Cache
    var cacheString = localStorage.getItem('captureState');
    if (cacheString) {
        var cache = JSON.parse(cacheString);
        supplier.value = cache.supplierId;
        eNumber.value = cache.en;
    }

    // Autofocus
    setTimeout(() => ean?.focus(), 50);

    // Neue E-Nummer
    qs('#btn-new-ebox')?.addEventListener('click', async () => {
        try {
            enableInputs(false);
            const printerId = qs('#printer_id')?.value;
            const data = await postJson(window.__CAPTURE_ENDPOINTS__.createEBox, {printer_id: Number(printerId)});
            eNumber.value = data.e_number;
            setLast({
                ean: data.e_number,
                name: 'E-Nummer erstellt',
                price: 0,
                print_status: 'printed',
                scanned_at: new Date().toISOString()
            });
            await loadHistoryForENumber(data.e_number);
            setTimeout(() => ean.focus(), 50);
        } catch (e) {
            showModal(e.message);
        } finally {
            enableInputs(true);
        }
    });

    qs('#btn-mass-new-ebox')?.addEventListener('click', async () => {
        try {
            enableInputs(false);
            const data = await postJson(window.__CAPTURE_ENDPOINTS__.createMassEBox, {newEboxes: 100});
            eNumber.value = data.e_number;
            setLast({
                ean: data.e_number,
                name: 'E-Nummer erstellt',
                price: 0,
                print_status: 'printed',
                scanned_at: new Date().toISOString()
            });
            await loadHistoryForENumber(data.e_number);
            setTimeout(() => ean.focus(), 50);
        } catch (e) {
            showModal(e.message);
        } finally {
            enableInputs(true);
        }
    });

    // EAN Enter => scan
    ean?.addEventListener('keydown', async (ev) => {
        if (ev.key !== 'Enter') return;
        ev.preventDefault();

        const supplierId = supplier.value;
        const en = eNumber.value.trim();
        const code = ean.value.trim();
        const scan_ohne_druck = scan_ohne_druck_input.checked ? 1 : 0;

        if (!supplierId) {
            showModal('Bitte Lieferant wählen.');
            return;
        }
        if (!en) {
            showModal('Bitte E-Nummer eingeben.');
            return;
        }
        if (!code) return;
        if (!quantity.reportValidity() || !Number.isSafeInteger(Number(quantity.value))) {
            showModal('Bitte eine positive ganze Zahl als Menge eingeben.');
            return;
        }

        try {
            // cache Data
            localStorage.setItem('captureState', JSON.stringify({supplierId: supplierId, en: en}));
            enableInputs(false);

            const data = await postJson(window.__CAPTURE_ENDPOINTS__.scan, {
                supplier_id: Number(supplierId),
                e_number: en,
                ean: code,
                quantity: Number(quantity.value),
                scan_ohne_druck: scan_ohne_druck,
            });

            setLast(data.scan);
            renderHistory(data.history || []);
            renderContent(data.content || []);
            ean.value = '';
            quantity.value = '1';
            setTimeout(() => ean.focus(), 30);

        } catch (e) {
            if (e.message.toLowerCase().match(/preis/)) {
                showModalAlert(e.message);
                ean.value = '';
                setTimeout(() => ean.focus(), 10);
            } else {
                // BLOCKING Fehler (Druck/Preis): UI bleibt stehen bis Nutzer OK drückt
                showModal(e.message);
                // trotzdem Input wieder aktivieren, sonst hängt man ohne Chance auf Retry
            }
        } finally {
            enableInputs(true);
        }
    });

    // Minus Buttons
    document.addEventListener('click', async (ev) => {

        const btn = ev.target?.closest?.('[data-minus]');
        const id = btn && Number(btn.getAttribute('data-minus'));

        const btnAll = ev.target?.closest?.('[data-minus-articles]');
        if (!btn && !btnAll) return;

        let eboxId, eanForDeletion = "";
        [eboxId, eanForDeletion] = btnAll.getAttribute('data-minus-articles').split("_");

        if ((eboxId || id) == false) {
            return;
        }

        try {
            enableInputs(false);
            var data = {};
            if (eboxId) {
                data = await postJson(window.__CAPTURE_ENDPOINTS__.minusArticles, {
                    ebox_id: eboxId,
                    ean: eanForDeletion
                });
            } else {
                data = await postJson(window.__CAPTURE_ENDPOINTS__.minus, {
                    scan_id: id,
                });
            }
            renderHistory(data.history || []);
            renderContent(data.content || []);
            setTimeout(() => ean.focus(), 30);
        } catch (e) {
            showModal(e.message);
        } finally {
            enableInputs(true);
        }
    });

    // Wenn E-Nummer geändert: History nachladen
    eNumber?.addEventListener('blur', async () => {
        const en = eNumber.value.trim();
        if (!en) return;
        await loadHistoryForENumber(en);
    });
}

document.addEventListener('DOMContentLoaded', initCapture);
